import Modal from "../modal/modal.js";

export default class UnsupportedBrowserPopup {
	constructor(config) {
		this.el =
			config.el || document.querySelector(".unsupported-browser-popup");
		this.main = document.getElementById("main");
		this.closeModal = this.el.querySelector(".js-close-modal");
		this.modal = null;
		this.init();
	}
	init() {
		if (sessionStorage.getItem("unsupportedBannerShown") != "true") {
			this.attachEvents();
			sessionStorage.setItem("unsupportedBannerShown", "true");
		}
	}
	attachEvents() {
		let self = this;
		this.openModal();

		this.closeModal.addEventListener("click", () => {
			self.modal.hide();
		});
	}
	openModal() {
		this.modal = new Modal(this.el);
		this.modal.show();
	}
}
